export default __webpack_public_path__ + "static/media/time-card.4344df76.svg";